const SoalAkmReq = {
    idBankSoal: null,
    id: null,
    pernyataan: '',
    kunciJawaban: null,
    teori: '',
}

export default SoalAkmReq;